import { UseFormReturn } from "react-hook-form";
import { DTOModule } from "../../types/building";
import StaticBox from "../Global/StaticBox";
import SelectEditor from "../Global/Editors/SelectEditor";
import { IModuleVärmePrimärPumpConfig } from "../../types/ModuleDatas";
import { useGlobalData } from "../GlobalDataProvider";
import { nameof } from "../Global/Utils";
import { MapTooltip } from "../../types/globalData";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
  usedAsFXSubsystem?: boolean;
}

const ConfigVarmePrimarPump = ({ module, data, formHook, usedAsFXSubsystem }: IProps) => {
  const globalData = useGlobalData();
  const värmepumpSystemtyper = globalData.data
    ? globalData.data.Värme.VärmepumpSystemtyp.filter((r) => (!usedAsFXSubsystem && !r.FinnsSomFX) || (usedAsFXSubsystem && r.FinnsSomFX))
    : [];
  const systemTypVarmepump = värmepumpSystemtyper.map((r) => r.VärmepumpSystemtyp);
  systemTypVarmepump.splice(0, 0, "");

  return (
    <>
      <div className="row ml-0">
        {usedAsFXSubsystem ? (
          <></>
        ) : (
          <>
            {/* <div className="col-lg-12">ConfigVarmePrimarPump</div>
            <div className="col-lg-12">
              <StaticBox label="Benämning på system" text={module.name}></StaticBox>
            </div> */}
          </>
        )}

        <div className="col-lg-12">
          <SelectEditor
            label="Ange om värmepumpen producerar tappvarmvatten"
            formHook={formHook}
            fieldName={nameof<IModuleVärmePrimärPumpConfig>("harProduktionVatten")}
            tooltipId={nameof<MapTooltip>("VärmePrimärPump_harProduktionVatten")}
            items={["Nej", "Ja"]}
          ></SelectEditor>
        </div>
        <div className="col-lg-12">
          <SelectEditor
            label="Ange om värmepumpen producerar värme till lokaler"
            formHook={formHook}
            fieldName={nameof<IModuleVärmePrimärPumpConfig>("harProduktionVärme")}
            tooltipId={nameof<MapTooltip>("VärmePrimärPump_harProduktionVärme")}
            items={["Nej", "Ja"]}
          ></SelectEditor>
        </div>
        <div className="col-lg-12">
          <SelectEditor
            label="Ange systemtyp för värmepump"
            formHook={formHook}
            fieldName={nameof<IModuleVärmePrimärPumpConfig>("systemTyp")}
            tooltipId={nameof<MapTooltip>("VärmePrimärPump_systemTyp")}
            items={systemTypVarmepump}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste göra ett val" : undefined;
                },
              },
            }}
          ></SelectEditor>
        </div>
      </div>
    </>
  );
};

export default ConfigVarmePrimarPump;
